import { render } from "./SectionHowto.vue?vue&type=template&id=3036d65c&scoped=true"
import script from "./SectionHowto.vue?vue&type=script&lang=js"
export * from "./SectionHowto.vue?vue&type=script&lang=js"

import "./SectionHowto.vue?vue&type=style&index=0&id=3036d65c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3036d65c"]])

export default __exports__